
// Never change order. Append new at end
export type Permission = typeof Permissions[number];


// Commands and queries using employee permissions will block execution if the portal is not enabled !!!
export const EmployeePermissions = [
    'CreateIncident',
    'PortalFiles',
    'PortalReports'
] as const;

// These permissions are related to employee actions but do not require the portal to be enabled, as they are used for features that are not exclusive to the portal (e.g. file upload slots)
export const NonBlockingEmployeePermissions = [
    'CreateFileUploadSlot',
    'ReferenceFiles',
    'ViewOrganization'
] as const;

export const IndividualPermissions = [
    'ManageIncidents'
] as const;

export type IndividualMemberPermission = typeof IndividualPermissions[number];

const Permissions = [
    'Login',
    'RefreshToken',
    'PortalLogin',
    'Logout',

    ...EmployeePermissions,
    ...NonBlockingEmployeePermissions,
    
    'RespondToIncidentMessage',

    'SuperAdmin',

    'FeatureFlags',

    'EditCourses',
    'ViewCourses',

    'UserAdmin', // All
    'ViewUsers',

    'ViewActivityOverview',
    'ViewActivity',
    'EditActivity',

    'ViewSurvey',
    'EditSurveys',
    'ViewSurveyReport',
    'DeleteAllSurveyAnswers',
    'PublicSurveyReportLink',

    'EditUser', // Own
    'GetActiveUser',

    'CreateUser',
    'RequestPasswordReset',

    'SendSurveyRespondentEmails',

    'SubmitSurveyAnswer',

    'EditSiteApplicationSettings',

    'EditActionPoints',
    'ViewActionPoints',

    'ActionPlans',
    'PublicActionPlanLink',

    'PublicArticle',

    'ViewNotifications',
    'EditNotifications',

    'EditLocations',
    'ViewLocations',

    'AssignedSafetyInspections',
    'AllSafetyInspections',

    'EditPersons',

    'DocumentArchive',

    'ViewArticles',
    'EditArticles',

    'EditOrganization',

    // anonymous
    'ViewCustomForm',
    'ViewCustomFormAnswer',
    'SubmitCustomFormAnswer',

    // member
    'ViewCustomFormList',
    'ViewCustomFormAnswerList',

    // admin
    'EditCustomForms',
    'AdminCustomFormAnswers',

    'ViewLearningModules',

    'ViewExternalLinks',
    'EditExternalLinks',

    'ReferenceLinks',
    'Comments',

    ...IndividualPermissions,

    'EmployeePortalLogin',

    'GetSitePartner',

    'ManageEmployeePortal'
    
] as const;